export default __webpack_public_path__ + "static/media/gallery - potions_05.6fe7f4ce.jpg";